module.exports = __webpack_public_path__ + "img/squiggle.9faae4c9.png";